/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { createGlobalStyle } from "styled-components";
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import { inputTextDate } from "../../utils/helpers/view/detailsHelper";
import { dateFr, lastMonthDate, maximumDate } from "../../utils/helper";
import ModernDatePicker from "./component/ModernDatePicker";

interface SearchDateProps {
  sendDates: (dates: any) => void;
}

const SearchDate = ({ sendDates }: SearchDateProps) => {
  //Variables
  const [startDate, setStartDate] = useState<any>();
  const [endDate, setEndDate] = useState<any>();
  const [viewLoaded, setViewLoaded] = useState(false); 

  // component did mount
  useEffect(() => {
    setStartDate({
      day: lastMonthDate().getDate(),
      month: lastMonthDate().getMonth() + 1,
      year: lastMonthDate().getFullYear(),
    });
    setEndDate({
      day: new Date().getDate(),
      month: new Date().getMonth()+1,
      year: new Date().getFullYear(),
    });
    setViewLoaded(true);
  }, []);

  useEffect(() => {
    // get data when dates are loaded at first view launch
    viewLoaded === true && sendDates({start: startDate, end: endDate});
  }, [viewLoaded]);

  return (
    <>
      <Container className="searchDateContainer">
        <Styles/>
        <Container automatedTestId="start-date" className="dateContainer" >
          <ModernDatePicker
            className="datePickFrom"
            inputPlaceholder="Du"
            value={startDate}
            shouldHighlightWeekends
            maximumDate={maximumDate()}
            formatInputText={() => {
              return inputTextDate(startDate);
            }}
            locale={dateFr}
            onChange={(date: any) => {
              setStartDate(date);
            }}
          />
        </Container>
        <Container automatedTestId="end-date" className="dateContainer">
          <ModernDatePicker
            className="datePickTo"
            inputPlaceholder="Au"
            value={endDate}
            locale={dateFr}
            shouldHighlightWeekends
            minimumDate={startDate}
            maximumDate={maximumDate()}
            formatInputText={() => {
              return inputTextDate(endDate);
            }}
            onChange={(date: any) => {
              setEndDate(date);
            }}
          />
        </Container>
        <Container className="submit-button">
          <Button automatedTestId="button-submit" className="export-btn" onClick={()=>viewLoaded === true && sendDates({start: startDate, end: endDate})} mode="plain">
            <Word variant="span" textStyle="normalBold" value="Rechercher" />
          </Button>
        </Container>
      </Container>
    </>
  );
};

const Styles = createGlobalStyle`
.sds-reset-style{
  div.sds-container.searchDateContainer{
    flex-direction: row;
    gap: 10px;
    align-items: center;
  }
  .sds-m-modern-date-picker .my-custom-input{
    background-color:#edf2fa;
    border-radius: 0%;
  }
  .sds-m-modern-date-picker{
    margin-bottom: 0px !important;
  }
}
`;
export default SearchDate;
